import { render, staticRenderFns } from "./wxsrule-add-or-update.vue?vue&type=template&id=d588dcc2&scoped=true&"
import script from "./wxsrule-add-or-update.vue?vue&type=script&lang=js&"
export * from "./wxsrule-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./wxsrule-add-or-update.vue?vue&type=style&index=0&id=d588dcc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d588dcc2",
  null
  
)

export default component.exports